import React from "react";

import NavigationScroll from "layout/NavigationScroll";
import RTLLayout from "layout/RTLLayout";
import Snackbar from "components/extended/Snackbar";
import ThemeCustomization from "themes";
import Endpoints from "core/endpoints";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { BASE_PATH } from "config";
import { pointLayerConfig } from "keplerConfigs/config/pointLayerConfig";
import Router from "./routes/Router";
import { HelmetProvider } from "react-helmet-async";
import { ConfigProvider } from "contexts/ConfigContext";
import { store } from 'store/app.store'

Endpoints.baseURL = process.env.REACT_APP_BASE_URL;

const App = () => (
  <HelmetProvider>
    <Provider store={store}>
      <ConfigProvider>
        <BrowserRouter basename={BASE_PATH}>
          <ThemeCustomization>
            <RTLLayout>
              <NavigationScroll>
                <>
                  <Router layerConfigs={[pointLayerConfig]} />
                  <Snackbar />
                </>
              </NavigationScroll>
            </RTLLayout>
          </ThemeCustomization>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  </HelmetProvider>
);

export default App;
